import _ from 'lodash'

const toTime = (policy) => {
  const time = new Date(_.get(policy, 'policyEffectiveDate')).getTime()
  return _.isNaN(time) ? null : time
}

const policyStatusPriority = ['1', '7', '4', '9']

const getPolicyStatusCode = (policy) => String(_.get(policy, 'policyStatusCode'))

const keepLatestPolicies = (policies = []) => {
  let latestPolicies = []

  policies.forEach((policy) => {
    if (_.isEmpty(latestPolicies)) {
      latestPolicies = [policy]
      return
    }

    const currentTime = toTime(latestPolicies[0])
    const nextTime = toTime(policy)

    if (currentTime == nextTime) {
      latestPolicies.push(policy)
      return
    }

    if (currentTime == null || (nextTime !== null && nextTime > currentTime)) {
      latestPolicies = [policy]
    }
  })
  console.log(latestPolicies)
  return latestPolicies
}

const getAcceptedPoliciesByStatusPriority = (policies = []) => {
  const acceptedStatus = _.find(policyStatusPriority, (status) =>
    _.some(policies, (policy) => getPolicyStatusCode(policy) === status)
  )

  if (_.isEmpty(acceptedStatus)) return []

  return policies.filter((policy) => getPolicyStatusCode(policy) === acceptedStatus)
}

const keepAcceptedPoliciesByNumber = (policies = []) => {
  const acceptedByStatus = getAcceptedPoliciesByStatusPriority(policies)
  return keepLatestPolicies(acceptedByStatus)
}

export const filterPolicyList = (policies = []) => {
  const userinfo = JSON.parse(localStorage.getItem('userInfo'))
  const agentCode = _.get(userinfo, 'AGENT_CODE', '')
  const filterAgentByUserInfo = policies.filter((policy) => policy.producingAgentCode1 === agentCode)
  const accepted = keepAcceptedPoliciesByNumber(filterAgentByUserInfo)
  const times = accepted.map(toTime).filter((time) => time !== null)
  if (_.isEmpty(times)) return []

  return accepted
}

const findPartyByRoleSuffix = (partyRoles, suffix) => {
  const response = _.find(partyRoles, (role) => {
    const roleCode = _.get(role, 'party.partyId', '')
    return roleCode.endsWith(suffix)
  })
  return response
}

const fullName = (party) => {
  const name = `${_.get(party, 'party.firstName', '')} ${_.get(party, 'party.lastName', '')}`.trim()
  return _.isEmpty(name) ? undefined : name
}

export const toPolicyDisplay = (policy) => {
  const partyRoles = _.get(policy, 'partyRoles', [])
  const insured = findPartyByRoleSuffix(partyRoles, ':INS')
  const owner = findPartyByRoleSuffix(partyRoles, ':OWN')
  return {
    appId: _.get(policy, 'policyNumber', ''),
    policyNo: _.get(policy, 'policyNumber', ''),
    productName: _.get(policy, 'product.productName') || _.get(policy, 'product.productCode', ''),
    insuredName: insured ? _.get(insured, 'party.firstName', '') : _.get(owner, 'party.firstName', ''),
    insuredLastname: insured ? _.get(insured, 'party.lastName', '') : _.get(owner, 'party.lastName', ''),
    payer: fullName(owner),
    policyEffectiveDate: _.get(policy, 'policyEffectiveDate', ''),
    policyEffectiveToDate: _.get(policy, 'policyExpirationDate', ''),
    beneficiary: _.get(policy, 'beneficiary', []).map((bene) => ({
      firstName: _.get(bene, 'beneficiaryFirstName', ''),
      lastName: _.get(bene, 'beneficiaryLastName', ''),
    })),
  }
}
